var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackFull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3713.04 288.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m3448.05,149.89c0-65.1,45.65-95.62,91.84-95.62h82.12c54.02,0,86.17,26.2,90.76,68.88h-68.07c-2.97-6.48-6.48-10.8-30.52-10.8h-61.32c-20.53,0-33.22,12.97-33.22,37.55s12.7,37.55,33.22,37.55h51.59c9.72,0,28.09-3.24,35.66-14.05h-58.89v-38.9h131.82v107.24h-49.97l-7.29-20.26c-8.91,14.05-28.9,24.31-58.35,24.31h-57.54c-46.19,0-91.84-27.82-91.84-95.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m3244.74,134.77v106.97h-79.15V58.05h89.14l99.13,94V58.05h79.42v183.68h-82.93l-105.62-106.97Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3068.78,
    y: 58.05,
    width: 79.15,
    height: 183.68
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "3059.22 242.01 2966.03 242.01 2909.03 180.69 2870.95 212.56 2870.95 241.74 2791.8 241.74 2791.8 58.05 2870.95 58.05 2870.95 132.34 2958.2 58.32 3001.69 58.05 3056.25 58.32 2959.28 138.82 3059.22 242.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2703.73,132.07c47.27,0,75.9,10.26,75.9,50.78,0,50.51-33.22,63.21-75.9,63.21h-118.31c-55.37,0-77.25-21.61-77.25-68.88h75.63c.81,10.26,11.89,10.53,21.34,10.53,28.9,0,79.42.27,92.65.27,7.29,0,9.99-2.97,9.99-10.53,0-4.86-3.24-7.02-10.53-7.02-37.28-.81-75.9-1.89-113.18-2.97-47.27,0-75.63-9.72-75.63-50.24,0-50.51,33.22-63.21,75.9-63.21h114.26c55.1,0,76.98,21.61,76.98,68.88h-75.63c-.81-10.53-11.62-10.8-21.34-10.8h-88.33c-7.29,0-9.99,2.7-9.99,10.26,0,4.86,2.7,6.75,9.99,6.75,37.28.81,75.9,1.89,113.45,2.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2266.86,241.74V58.05h228.25v54.29h-149.11v16.21h136.41v42.95h-136.41v15.94h149.11v54.29h-228.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2150.3,183.39c20.53,0,29.71-11.62,29.71-33.5s-9.18-33.5-29.71-33.5h-79.96v66.99h79.96Zm101.57-33.5c0,65.37-45.65,91.84-91.84,91.84h-169.1V58.05h169.1c46.19,0,91.84,26.74,91.84,91.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1746.93,241.74V58.05h228.25v54.29h-149.11v16.21h136.41v42.95h-136.41v15.94h149.11v54.29h-228.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1545.13,149.89c0,24.58,12.7,37.55,33.22,37.55h38.9c20.26,0,32.96-12.97,32.96-37.55V58.05h79.15v91.84c0,65.37-45.65,95.89-91.84,95.89h-79.69c-46.19,0-91.84-30.52-91.84-95.89V58.05h79.15v91.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1276.6,116.4v21.88h78.61c20.53,0,24.85-.54,24.85-10.8s-4.32-11.08-24.85-11.08h-78.61Zm82.39,125.34l-44.3-49.97h-38.09v49.97h-79.42V58.05h165.31c46.19,0,86.98,2.16,86.98,69.42,0,39.44-18.64,55.1-50.51,59.43l52.13,54.83h-92.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1179.5,58.05v60.24h-95.35v123.45h-79.15v-123.45c-40.52.27-76.71.27-95.08.27v-60.51h269.58Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m0,0v90.86h147.65l.58,197.15,124.2-196.91.15-.24c63.73.42,117.45-.6,146.35-.6V0H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m311.25,197.04h222.29c32.29,0,46.74-18.27,46.74-52.69s-14.45-52.69-46.74-52.69l-114.62-1.41L477.15,0h78.11c70.41,2.42,138.04,44.97,138.04,144.35s-71.81,144.46-144.46,144.46H253.32l57.93-91.78Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackFull);
export default __webpack_public_path__ + "static/media/black-full.14756df1fc292b052b08c3e3e6286836.svg";
export { ForwardRef as ReactComponent };